import React from "react";

import "./App.css";
import "./weather-icons/css/weather-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Weather from "./app_component/weather.component";
import Form from "./app_component/form.component";

//api call api.openweathermap.org/data/2.5/weather?q={city name},{state code}&appid={API key}
const API_key = "7815810b8b505ccef1994c6e1417c9c9";

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      city: undefined,
      country: undefined,
      icon: undefined,
      main: undefined,
      celsius: undefined,
      temp_max: undefined,
      temp_min: undefined,
      description: "",
      error: false,
    };
    // this.getWeather();

    this.weatherIcon = {
      Thunderstorm: "wi-thunderstorm",
      Drizzle: "wi-showers",
      Rain: "wi-rain",
      HeavyRain: "wi-storm-showers",
      ShowerRain: "wi-showers",
      Snow: "wi-snow",
      Fog: "wi-fog",
      Smoke: "wi-smoke",
      Haze: "wi-day-haze",
      Dust: "wi-dust",
      Ash: "wi-volcano",
      Tornado: "wi-tornado",
      Clear: "wi-day-sunny",
      Clouds: "wi-cloud",
      Cloudbroken: "wi-fog",
      Cloudy: "wi-cloudy",
    };
  }
  //METHODS
  calCelsius(temp) {
    let cell = Math.floor(temp - 273.15);
    return cell;
  }

  getWeatherIcon(icons, rangeId) {
    switch (true) {
      case rangeId >= 211 && rangeId <= 232:
        this.setState({ icon: this.weatherIcon.Thunderstorm });
        break;
      case rangeId >= 200 && rangeId <= 210:
        this.setState({ icon: this.weatherIcon.HeavyRain });
        break;
      case rangeId >= 300 && rangeId <= 321:
        this.setState({ icon: this.weatherIcon.Drizzle });
        break;
      case rangeId === 500 || rangeId === 501:
        this.setState({ icon: this.weatherIcon.Rain });
        break;
      case rangeId === 511 ||
        rangeId === 520 ||
        rangeId === 521 ||
        rangeId === 522 ||
        rangeId === 521:
        this.setState({ icon: this.weatherIcon.ShowerRain });
        break;
      case rangeId === 502 || rangeId === 503 || rangeId === 504:
        this.setState({ icon: this.weatherIcon.HeavyRain });
        break;
      case rangeId >= 600 && rangeId <= 622:
        this.setState({ icon: this.weatherIcon.Snow });
        break;
      case rangeId === 741:
        this.setState({ icon: this.weatherIcon.Fog });
        break;
      case rangeId === 711:
        this.setState({ icon: this.weatherIcon.Smoke });
        break;
      case rangeId === 721:
        this.setState({ icon: this.weatherIcon.Haze });
        break;
      case rangeId === 731 || rangeId === 751 || rangeId === 761:
        this.setState({ icon: this.weatherIcon.Dust });
        break;
      case rangeId === 762:
        this.setState({ icon: this.weatherIcon.Ash });
        break;
      case rangeId === 781 || rangeId === 771:
        this.setState({ icon: this.weatherIcon.Tornado });
        break;
      case rangeId === 800:
        this.setState({ icon: this.weatherIcon.Clear });
        break;
      case rangeId === 801:
        this.setState({ icon: this.weatherIcon.Clouds });
        break;
      case rangeId === 802 || rangeId === 803:
        this.setState({ icon: this.weatherIcon.Cloudbroken });
        break;
      case rangeId === 804:
        this.setState({ icon: this.weatherIcon.Cloudy });
        break;
      default:
        this.setState({ icon: this.weatherIcon.Cloudbroken });
    }
  }

  getWeather = async (e) => {
    e.preventDefault();

    const city = e.target.elements.city.value;
    // const country = e.target.elements.country.value;

    //if(city && country)
    if (city) {
      const api_call = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_key}`
      );
      const response = await api_call.json();

      console.log(response);
      this.setState({
        city: `${response.name}`,
        country: response.sys.country,
        celsius: this.calCelsius(response.main.temp),
        temp_max: this.calCelsius(response.main.temp_max),
        temp_min: this.calCelsius(response.main.temp_min),
        description: response.weather[0].description,
        error: false,
      });
      this.getWeatherIcon(this.weatherIcon, response.weather[0].id);
    } else {
      this.setState({
        error: true,
      });
    }
  };
  render() {
    return (
      <div className="App">
        <Form loadweather={this.getWeather} error={this.state.error} />
        <Weather
          city={this.state.city}
          country={this.state.country}
          temp_celsius={this.state.celsius}
          temp_max={this.state.temp_max}
          temp_min={this.state.temp_min}
          description={this.state.description}
          weatherIcon={this.state.icon}
        />
      </div>
    );
  }
}

export default App;
